import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import i18n from './i18n';

// テキストコピー
import VueClipboard from 'vue-clipboard2';
// レスポンシブ
import VueMq from 'vue-mq';
// スワイプ
import VueTouch from 'vue-touch';

Vue.config.productionTip = false;

Vue.use(VueClipboard);

Vue.use(VueMq, {
  breakpoints: {
    viewSm: 450,
    viewMd: 896,
    viewLg: Infinity,
  },
  defaultBreakpoint: 'viewSm',
});

Vue.use(VueTouch, {name: "v-touch"});

new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
